export default __webpack_public_path__ + "static/media/apple-touch-icon-72x72.045bba19.png";